const contact = () => import(/* webpackChunkName: "contact" */ "./contact.vue");

export default {
  name: "联系我们",
  path: "/contact",
  component: contact,
  meta: { show: true },
};
